import { CallGETAPI, CallPOSTAPI } from "../../helper/Constants";

export const fetchCallDetail = async (startDate, endDate) => {
  try {
    const response = await CallPOSTAPI("api/get-cdr-date-Call-Processed2", {
      start_time: startDate,
      end_time: endDate,
    });

    if (response.status) {
      return {
        data: response.data.data,
        totals: response.data.totals,
      };
    }
    return null;
  } catch (error) {
    console.error("Error fetching call details:", error);
    return null;
  }
};

export const fetchPieChartData = async (startDate, endDate) => {
  try {
    const response = await CallPOSTAPI("api/get-cdr-date-Call-Extensions", {
      start_time: startDate,
      end_time: endDate
    });
    
    if (response.status && response.data && response.data.data) {
      const result = response.data?.totals;
      return [
        { name: "Total Calls", y: parseInt(result.incoming) || 0 },
        { name: "Missed Calls", y: parseInt(result.miscall) || 0 },
        { name: "Answered Calls", y: parseInt(result.answer) || 0 },
        { name: "Canceled Calls", y: parseInt(result.cancelcalls) || 0 },
      ];
    }
    return [];
  } catch (error) {
    console.error("Error fetching pie chart data:", error);
    return [];
  }
};

export const fetchTopUsersData = async (startDate, endDate) => {
    if (!startDate || !endDate) return [];
    
    try {
      const formattedStartDate = new Date(startDate).toISOString().split('T')[0];
      const formattedEndDate = new Date(endDate).toISOString().split('T')[0];
      
      const response = await CallGETAPI(
        `api/top-by-duration?start_time=${formattedStartDate}&end_time=${formattedEndDate}`
      );
      
      if (response.status && response.data && response.data.data) {
        // Access the data array from response.data.data
        return response.data.data
          .map(user => ({
            name: user.name || 'Unknown User',
            y: (parseInt(user.total_duration) || 0) / 60, // Convert seconds to minutes
            user_id: user.user_id
          }))
          .filter(user => user.y > 0);
      }
      return [];
    } catch (error) {
      console.error("Error fetching top users data:", error);
      return [];
    }
  };
  

export const processChartData = (data, startDate, endDate) => {
  const dataMap = new Map(
    data.map(item => [
      item.call_date.split('T')[0],
      {
        incoming: parseFloat(item.incoming) || 0,
        answer: parseFloat(item.answer) || 0,
        miscall: parseFloat(item.miscall) || 0,
        cancelcalls: parseFloat(item.cancelcalls) || 0,
        profit: parseFloat(item.total_margin) || 0,
      }
    ])
  );

  const allDates = [];
  const currentDate = new Date(startDate);
  const endDateTime = new Date(endDate);

  while (currentDate <= endDateTime) {
    const dateString = currentDate.toISOString().split('T')[0];
    const existingData = dataMap.get(dateString) || {
      incoming: 0,
      answer: 0,
      miscall: 0,
      cancelcalls: 0,
      profit: 0
    };

    allDates.push({
      x: currentDate.getTime(),
      date: dateString,
      ...existingData
    });

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return allDates;
};